import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { SPACE_RECORDS_SELECTION_TARGET } from '../../../constants'
import type { Plugin } from '../plugin'

/**
 * Releases the selected cluster when the workflow ends.
 */
export const releaseClusterSelection = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    rxjs
      .merge(
        feature.actions.cancel.observe(),
        feature.actions.initiate.cancellation.observe(),
        feature.actions.submit.success.observe(),
        plugin.collection.feature.actions.changeContext.observe(),
      )
      .pipe(
        rxjs.map(action =>
          plugin.clustersEc.plugins.selectionPlugin.applied.actions.putInSelectionLookup
            .from(action)
            .create({
              key: SPACE_RECORDS_SELECTION_TARGET,
              value: { release: true },
            }),
        ),
      ),
)
